import { IAsyncError } from "../common";
import { snakeCase } from "@lialo/common/lib/string";

export function errorTranslationKey(error: IAsyncError): string {
  if (error.errorCode === undefined) {
    return 'errors.unspecified_errorcode';
  }
  return `errors.${snakeCase(error.errorCode)}`;
}
